import React from 'react';
import useSWR from 'swr';
import { fetcher } from 'utilities/axios.fetchers';

//━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
export const useFetch = ({
  url = null,
  sec = 0,
  file = 'N/A',
  done = () => {},
  setter = null
}) => {
  const [hasFetched, setHasFetched] = React.useState(false); // Track if data has been fetched

  const config = {
    revalidateIfStale: false,
    revalidateOnFocus: true,
    revalidateOnReconnect: false,
    refreshInterval: sec ? Number(sec) * 1000 : 0
  };

  // Success and error callbacks for SWR
  const success_ = (data, key) => {
    if (!hasFetched) {
      done(data); // Call done only once when data is fetched
      setHasFetched(true); // Mark as fetched
    }
  };

  const error_ = (err, key) => {
    console.error(`Error occurred in fetching data from ${file}:`, err);
  };

  // SWR Configuration
  const { data, error, isValidating, mutate } = useSWR(url, fetcher, {
    ...config,
    onSuccess: success_,
    onError: error_
  });

  // Throwing error if something went wrong after fetch attempt
  // if (error && !url?.includes('unitscompare')) {
  //   const message = error ? error.message : `Error fetching data from ${file}: No data returned`;
  //   throw new Error(message);
  // }

  return { D: data, L: isValidating, E: error, mutate };
};
//━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
